export class FieldMapSettingsModel {
    constructor(public selectedEnvironments?: number[],
                public rowsInBlock?: number,
                public  rangesInBlock?: number,
                public rowsPerPlot?: number,
                public column?: number,
                public range?: number,
                public isSerpentine?: boolean,
                public machineCapacity?: number,
                public deletedPlotCoordinates?: string[]) {
    }
}